import * as React from "react";
import { Box, TextField } from "@mui/material";
import { styled } from "@mui/material/styles";

export function SetupInput({ setupName, onSetupNameChange }) {
    const handleChange = (event) => {
        onSetupNameChange(event.target.value);
    };

    return (
        <SetupContainer>
            <InputWrapper>
                <TextField
                    id="setupName"
                    label="Grow Setup Name"
                    value={setupName}
                    onChange={handleChange}
                    variant="outlined"
                    fullWidth
                    InputProps={{
                        endAdornment: (
                            <IconWrapper>
                                <IconContainer>
                                    <Box
                                        component="img"
                                        src="https://cdn.builder.io/api/v1/image/assets/1d0bf245527641fd911dd14fadbc6fdd/33ddc7e6337492ed1c16fbdbcc58c3bdee9fdce6ee86ec19d9e297bcfc25449f?apiKey=1d0bf245527641fd911dd14fadbc6fdd&"
                                        alt=""
                                        sx={{
                                            width: '24px',
                                            aspectRatio: '1',
                                            objectFit: 'contain'
                                        }}
                                        loading="lazy"
                                    />
                                </IconContainer>
                            </IconWrapper>
                        )
                    }}
                    sx={{
                        '& .MuiOutlinedInput-root': {
                            backgroundColor: 'black',
                            borderRadius: '4px 4px 0 0'
                        }
                    }}
                />
            </InputWrapper>
            <ActiveIndicator />
            <SupportText />
        </SetupContainer>
    );
}

const SetupContainer = styled(Box)(({ theme }) => ({
    borderRadius: '4px 4px 0 0',
    boxShadow: '5px 4px 4px rgba(0, 0, 0, 0.75)',
    position: 'relative',
    display: 'flex',
    width: '100%',
    flexDirection: 'column'
}));

const InputWrapper = styled(Box)(({ theme }) => ({
    borderRadius: '4px 4px 0 0',
    backgroundColor: theme.palette.grey[100],
    zIndex: 0,
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
    flex: 1
}));

const IconWrapper = styled(Box)({
    display: 'flex',
    minHeight: '48px',
    alignItems: 'center',
    justifyContent: 'center',
    width: '48px'
});

const IconContainer = styled(Box)({
    borderRadius: '100px',
    display: 'flex',
    width: '40px',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '8px'
});

const ActiveIndicator = styled(Box)(({ theme }) => ({
    backgroundColor: theme.palette.text.secondary,
    minHeight: '1px',
    width: '100%',
    border: `1px solid ${theme.palette.text.secondary}`
}));

const SupportText = styled(Box)({
    position: 'absolute',
    display: 'flex',
    minHeight: '20px',
    width: '100%',
    paddingTop: '4px',
    gap: '10px',
    left: 0,
    bottom: '-20px',
    height: '20px'
});